import { z } from "zod"

export const PublicStoreEmployeeSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  photo: z.string().url(),
  storeId: z.string().uuid(),
})

export const CreatePublicStoreEmployeeSchema = PublicStoreEmployeeSchema.omit({
  id: true,
})
export const CreatePublicStoreEmployeeSchemaWithoutPhoto =
  CreatePublicStoreEmployeeSchema.omit({ photo: true })
export const UpdatePublicStoreEmployeeSchema =
  CreatePublicStoreEmployeeSchema.partial().omit({ storeId: true })
export const UpdatePublicStoreEmployeeSchemaWithoutPhoto =
  CreatePublicStoreEmployeeSchemaWithoutPhoto.partial()

export type PublicStoreEmployee = z.infer<typeof PublicStoreEmployeeSchema>
export type CreatePublicStoreEmployee = z.infer<
  typeof CreatePublicStoreEmployeeSchema
>
export type CreatePublicStoreEmployeeWithoutPhoto = z.infer<
  typeof CreatePublicStoreEmployeeSchemaWithoutPhoto
>
export type UpdatePublicStoreEmployee = z.infer<
  typeof UpdatePublicStoreEmployeeSchema
>
export type UpdatePublicStoreEmployeeWithoutPhoto = z.infer<
  typeof UpdatePublicStoreEmployeeSchemaWithoutPhoto
>
